import { useParams } from 'react-router-dom'

export const useStringParams = (paramName: string): string => {
  const params = useParams()
  return params[paramName] ?? ''
}
